import type { ApiRouteModule } from '@/lib/api-reference';
import type { OpenApiMcpOperation } from '@/lib/openapi-mcp-tools';

/** Préfixes REST masqués dans la doc MCP LyrraOne (formateur solo). */
const EXCLUDED_PATH_PREFIXES = [
  '/api/admin',
  '/api/institutions',
  '/api/institution',
  '/api/v2/',
] as const;

function isExcludedApiPath(path: string): boolean {
  const normalized = path.toLowerCase();
  return EXCLUDED_PATH_PREFIXES.some((prefix) => {
    const base = prefix.endsWith('/') ? prefix.slice(0, -1) : prefix;
    return normalized === base || normalized.startsWith(`${base}/`);
  });
}

function isExcludedApiPrefix(prefix: string): boolean {
  return isExcludedApiPath(prefix);
}

function isExcludedOpenApiTag(tag: string): boolean {
  const tl = tag.toLowerCase();
  if (tl === 'admin' || tl.startsWith('admin/')) return true;
  if (tl.includes('institution')) return true;
  if (tl.startsWith('v2/')) return true;
  return false;
}

export function isFormateurMcpOperationExcluded(op: Pick<OpenApiMcpOperation, 'path' | 'tag'>): boolean {
  return isExcludedApiPath(op.path) || isExcludedOpenApiTag(op.tag);
}

export function filterFormateurMcpOperations(ops: OpenApiMcpOperation[]): OpenApiMcpOperation[] {
  return ops.filter((op) => !isFormateurMcpOperationExcluded(op));
}

export function filterFormateurApiV1Modules(modules: readonly ApiRouteModule[]): ApiRouteModule[] {
  return modules.filter((m) => !isExcludedApiPrefix(m.prefix));
}
